import {
  SystemCodeAddress,
  SystemCodeAddressFromJSON,
  UpdateSystemCodeAddressRequest,
  UpdateSystemCodeAddressRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemCodeAddressApi extends runtime.BaseAPI {
  async getAllSystemCodeAddress(
    code: string = ''
  ): Promise<SystemCodeAddress[]> {
    const queryParameters: runtime.HTTPQuery =
      code !== ''
        ? {
            code
          }
        : {}

    const response = await this.requestGet(
      `/system-code-addresses`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemCodeAddressFromJSON)
    ).value()
  }

  async updateSystemCodeAddress(
    request: UpdateSystemCodeAddressRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateSystemCodeAddressRequestToJSON(
      request
    )
    const response = await this.requestPut(
      '/system-code-addresses',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
